class CondenseContent extends HTMLElement {
  constructor() {
    super()
    this.toogleButton = this.querySelector('.content-toggle')
    this.truncateContent = this.querySelector('.condensed-content')
    this.truncateContentMobile = this.querySelector('.condensed-content-mobile')
    this.completeContent = this.querySelector('.complete-content')
    this.showMoreText = this.dataset.showMoreText
    this.showLessText = this.dataset.showLessText
  }

  connectedCallback() {
    this.toogleButton.addEventListener('click', ()=> {
      if(this.classList.contains('collapsed')) {
        this.truncateContent.classList.add('hidden')
          if (this.truncateContentMobile){
            this.truncateContentMobile.classList.add('hidden')
          }
          if(  this.completeContent){
             this.completeContent.classList.remove('hidden')
          }
          
       
        this.toogleButton.textContent = this.showLessText
      } else {
        this.truncateContent.classList.remove('hidden')
         if (this.truncateContentMobile){
            this.truncateContentMobile.classList.remove('hidden')
         }
         if(  this.completeContent){
           this.completeContent.classList.add('hidden')
         }
        
        this.toogleButton.textContent = this.showMoreText
      }

      this.classList.toggle('collapsed')
    })
  }
}

customElements.define('condensed-content', CondenseContent)

class SwatchesModal extends HTMLElement {
  constructor() {
    super()
    this.modal = this.querySelector('.product-item__swatches__modal')
    this.closeButton = this.modal.querySelector('.product-item__swatches__modal__inner__header__close__button')
    this.openButton = this.querySelector('.product-item__swatches__count.product-item__swatches__count--swatches-modal-new')
    this.productItem = this.closest('.product-item')
    this.overlay = this.querySelector('.overlay')
  }

  connectedCallback() {
    this._modalPlaceholder = document.createComment('swatches-modal-portal')
    this.modal.after(this._modalPlaceholder)

    this.openButton.addEventListener('click', () => {
      this.openModal()
    })

    this.closeButton.addEventListener('click', () => {
      this.closeModal()
    })

    this._overlayClickHandler = (e) => {
      if (e.target === this.modal) {
        this.closeModal()
      }
    }
  }

  closeModal() {
    this.setAttribute('aria-open', 'false')
    this.modal.setAttribute('aria-open', 'false')
    document.documentElement.removeAttribute('swatches-modal-open')
    setTimeout(() => {
      this.productItem.setAttribute('aria-open', 'false')
      if (this.modal.parentNode === document.body) {
        this._modalPlaceholder.after(this.modal)
        this._modalPlaceholder.after(this.overlay)
        document.body.removeEventListener('click', this._overlayClickHandler)
      }
    }, 300)
  }

  openModal() {
    document.body.appendChild(this.modal)
    document.body.appendChild(this.overlay)
    document.body.addEventListener('click', this._overlayClickHandler)
    this.modal.setAttribute('aria-open', 'true')
    this.productItem.setAttribute('aria-open', 'true')
    this.setAttribute('aria-open', 'true')
    this.scrollY = window.scrollY
    document.documentElement.setAttribute('swatches-modal-open', 'true')
  }
}
customElements.define('swatches-modal', SwatchesModal)

window.addEventListener('pageshow', function (event) {
  const modalSwatches = document.querySelectorAll('swatches-modal')
  modalSwatches.forEach(modal => {
    modal.closeModal()
  })
});